import React, { Component } from 'react'
import { Row, Col, Icon, Form, Select, Upload, Button, Input, Spin } from 'antd'
import BraftEditor from 'braft-editor'
import { ContentUtils } from 'braft-utils'
import 'braft-editor/dist/index.css'
import PropTypes from 'prop-types'
import { app, config, api } from "../../../app"

const Option = Select.Option
const FormItem = Form.Item

/**
 * 上传之前
 * @param file
 */
function beforeUpload (file) {
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
        app.alert('图片最大2MB！', 'error')
        return Promise.reject(false)
    }
    return Promise.resolve(true)
}

/**
 * 上传之前2
 * @param file
 */
function beforeUpload2 (file) {
    const isLt2M = file.size / 1024 / 1024 < 2, types = ['image/png', 'image/jpeg', 'image/gif', 'image/webp']
    if (!isLt2M) {
        app.alert('图片最大2MB！', 'error')
        return Promise.reject(false)
    } else if (types.indexOf(file.type) === -1) {
        app.alert('仅支持上传【.png, .jpg, .gif】！', 'error')
        return Promise.reject(false)
    }

    return Promise.resolve(true)
}

class NewsAdd extends Component {
    constructor (props) {
        super(props)
        this.state = {
            levelList: [],
            objList: [],
            editData: {}
        }
    }

    async componentDidMount () {
        this._isMounted = true
        if (this.props.edit_id) {
            await this.handleDetailData(this.props.edit_id)
        }
        await this.handleNewsLevelData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 打开详情
     */
    handleDetailData = async (id) => {
        await this.setData({ detail_loading: true })
        let { flag, data, msg } = await app.post(api.NewNewsDetails, {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        if (flag !== 1) {
            app.alert(msg, 'error')
        }
        await app.sleep(2000)
        this.props.form.setFieldsValue({
            news_title: data.news_title,
            news_content: BraftEditor.createEditorState(data.news_content),
            news_img: [{
                uid: '-1',
                name: 'news.png',
                status: 'done',
                response: {
                    flag: 1,
                    data: { url: data.news_img }
                },
                url: config.imgUrl + data.news_img
            }]
        })
        await this.setData({ detail_loading: false, editData: data })
    }

    /**
     * 编辑器图片上传
     * @param file
     * @returns {boolean}
     */
    editorUploadHandler = ({ file }) => {
        if (!file) {
            return false
        }
        if (file.status === 'done' && file.response && file.response.flag === 1) {
            this.props.form.setFieldsValue({
                news_content: ContentUtils.insertMedias(this.props.form.getFieldValue('news_content'), [{
                    type: 'IMAGE',
                    url: config.imgUrl + file.response.data.url
                }])
            })
        } else if (file.status === 'error') {
            app.alert('上传失败', 'error')
        }
    }

    /**
     * 预览
     */
    handlePreview = () => {
        const html = this.props.form.getFieldValue('news_content').toHTML()
        console.log(html)
        if (!html || html === '<p></p>') {
            app.alert('您填写内容后才可预览！', 'warn')
            return
        }
        if (window.previewWindow) {
            window.previewWindow.close()
        }
        window.previewWindow = window.open()
        window.previewWindow.document.write(html)
        window.previewWindow.document.close()

    }

    /**
     * 预览HTML
     **/
    buildPreviewHtml = (html) => {
        return `
              <!Doctype html>
              <html>
                <head>
                  <title>预览内容</title>
                  <style>
                    html,body{
                      height: 100%;
                      margin: 0;
                      padding: 0;
                      overflow: auto;
                      background-color: #f1f2f3;
                    }
                    .container{
                      box-sizing: border-box;
                      width: 1000px;
                      max-width: 100%;
                      min-height: 100%;
                      margin: 0 auto;
                      padding: 30px 20px;
                      overflow: hidden;
                      background-color: #fff;
                      border-right: solid 1px #eee;
                      border-left: solid 1px #eee;
                    }
                    .container img,
                    .container audio,
                    .container video{
                      max-width: 100%;
                      height: auto;
                    }
                    .container p{
                      white-space: pre-wrap;
                      min-height: 1em;
                    }
                    .container pre{
                      padding: 15px;
                      background-color: #f1f1f1;
                      border-radius: 5px;
                    }
                    .container blockquote{
                      margin: 0;
                      padding: 15px;
                      background-color: #f1f1f1;
                      border-left: 3px solid #d1d1d1;
                    }
                  </style>
                </head>
                <body>
                  <div class="container">${html}</div>
                </body>
              </html>
            `
    }

    /**
     * 提交
     **/
    handleAdd = (e) => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll(async (err, values) => {
                if (!err) {
                    await this.setData({ submit_loading: false })
                    if (values.news_img && values.news_img[0] && values.news_img[0].response && values.news_img[0].response.flag === 1) {
                        values.news_img = values.news_img[0].response.data.url
                    } else {
                        values.news_img = ''
                    }
                    values.indexno = app.getData('indexno')
                    values.account = app.getData('account')
                    values.news_content = values.news_content.toHTML()
                    const { edit_id } = this.props
                    let result = {}
                    if (edit_id) {
                        values.id = edit_id
                        result = await app.post(api.NewsEdit, values)
                    } else {
                        result = await app.post(api.NewsAdd, values)
                    }
                    if (result.flag === 1) {
                        app.alert("提交成功", "success")
                        this.props.onClose(true)
                    } else {
                        app.alert(result.msg || '提交失败', "error")
                    }
                }
            }
        )
    }

    /**
     * 获取新闻级别
     * @returns {Promise<void>}
     */
    handleNewsLevelData = async () => {
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account')
        }, { flag, data, msg } = await app.post(api.Newslevel, params)
        if (flag !== 1) {
            data = []
            app.alert(msg, 'error')
        }
        await this.setData({ levelList: data })
    }

    /**
     * 获取新闻对象
     * @returns {Promise<void>}
     */
    handleNewsObjectData = async (level) => {
        if (level && level === '1') return
        await this.setData({ obj_loading: true })
        this.props.form.setFieldsValue({ object: undefined })
        let params = {
            level,
            indexno: app.getData('indexno'),
            account: app.getData('account')
        }, { flag, data, msg } = await app.post(api.NewsReleaseObject, params)
        if (flag !== 1) {
            data = []
            app.alert(msg, 'error')
        }
        await this.setData({ objList: data, obj_loading: false })
    }

    render () {
        let formItemLayout = {
                labelCol: { span: 3 },
                wrapperCol: { span: 6 },
            },
            { edit_id } = this.props,
            { getFieldDecorator, getFieldsValue } = this.props.form,
            { levelList, obj_loading, objList, detail_loading, editData } = this.state,
            formData = getFieldsValue(['news_img', 'object_type'])
        const excludeControls = ['media', 'emoji', 'code'], extendControls = [
            {
                key: 'custom-button',
                type: 'button',
                text: '预览',
                onClick: this.handlePreview
            },
            {
                key: 'antd-uploader',
                type: 'component',
                component: (
                    <Upload
                        accept="image/png,image/jpeg,image/gif"
                        showUploadList={false}
                        action={config.serverUrl + api.ImageUpload}
                        beforeUpload={beforeUpload2}
                        data={{
                            token: app.getData('token'),
                            indexno: app.getData('indexno'),
                            account: app.getData('account'),
                            upload_type: 'news'
                        }}
                        name="image"
                        onChange={(file) => this.editorUploadHandler(file)}
                    >
                        {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
                        <button type="button" className="control-item button upload-button" data-title="插入图片">
                            <Icon type="picture" theme="filled"/>
                        </button>
                    </Upload>
                )
            }
        ]
        return (
            <div>
                {detail_loading ? (<div style={{ textAlign: 'center' }}><Spin size="large"/></div>) : null}
                <Form onSubmit={this.handleAdd} hidden={detail_loading}>
                    <FormItem
                        {...formItemLayout}
                        label="封面图片"
                    >
                        {getFieldDecorator('news_img', {
                            rules: [{
                                required: true, message: '请上传封面图片！',
                            }],
                            valuePropName: 'fileList',
                            getValueFromEvent: (e) => {
                                if (Array.isArray(e)) {
                                    return e
                                }
                                return e && e.fileList
                            },
                            initialValue: []
                        })(
                            <Upload
                                accept='image/jpeg, image/jpg, image/png'
                                action={config.serverUrl + api.ImageUpload}
                                disabled={formData.news_img && formData.news_img.length >= 1}
                                beforeUpload={beforeUpload}
                                data={{
                                    token: app.getData('token'),
                                    indexno: app.getData('indexno'),
                                    account: app.getData('account'),
                                    upload_type: 'news_cover'
                                }}
                                name="image"
                                listType="picture"
                                showUploadList={true}
                                className="upload-list-inline"
                            >
                                <Button disabled={formData.news_img && formData.news_img.length >= 1}>
                                    <Icon type="upload"/> 点击上传
                                </Button>
                            </Upload>
                        )}
                    </FormItem>
                    {
                        edit_id ? (
                            <span>
                                <FormItem
                                    {...formItemLayout}
                                    label="新闻级别"
                                >
                                    <span className="ant-form-text">{editData.object_name}</span>
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="发布对象"
                                >
                                    <span className="ant-form-text">{editData.object}</span>
                                </FormItem>
                            </span>
                        ) : (
                            <span>
                                <FormItem
                                    {...formItemLayout}
                                    label="新闻级别"
                                >
                            {getFieldDecorator('object_type', {
                                rules: [{
                                    required: true, message: '请选择新闻级别！',
                                }],
                            })(
                                <Select placeholder="请选择" onChange={this.handleNewsObjectData}>
                                    {
                                        levelList.map((level, i) => {
                                            return (
                                                <Option key={i} value={level.value}>{level.level}</Option>
                                            )
                                        })
                                    }
                                </Select>
                            )}
                        </FormItem>
                                {
                                    '23'.indexOf(formData.object_type) !== -1 ? (
                                        <FormItem
                                            {...formItemLayout}
                                            label="发布对象"
                                        >
                                            {getFieldDecorator('object', {
                                                rules: [{
                                                    required: true, message: '请选择发布对象！',
                                                }]
                                            })(
                                                <Select showSearch placeholder="请选择" optionFilterProp="children"
                                                        notFoundContent={obj_loading ? <Spin size="small"/> : null}>
                                                    {
                                                        objList.map((obj, i) => {
                                                            return (
                                                                <Option key={i}
                                                                        value={obj.object}>{obj.name}</Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            )}
                                        </FormItem>
                                    ) : null
                                }
                            </span>
                        )
                    }
                    <FormItem label="新闻标题" labelCol={{ span: 3 }} wrapperCol={{ span: 19 }}>
                        {getFieldDecorator('news_title', {
                            rules: [{
                                required: true, message: '请输入新闻标题！',
                            }]
                        })(
                            <Input placeholder="请填写"/>
                        )}
                    </FormItem>
                    <FormItem label="新闻内容" labelCol={{ span: 3 }} wrapperCol={{ span: 19 }}>
                        {getFieldDecorator('news_content', {
                            validateTrigger: 'onBlur',
                            initialValue: BraftEditor.createEditorState(null),
                            rules: [{
                                required: true,
                                validator: (_, value, callback) => {
                                    if (value.isEmpty()) {
                                        callback('请输入新闻内容')
                                    } else {
                                        callback()
                                    }
                                }
                            }],
                        })(
                            <BraftEditor
                                style={{ border: '1px solid #eee' }}
                                excludeControls={excludeControls}
                                extendControls={extendControls}
                                stripPastedStyles={true}
                                placeholder="请输入新闻内容"
                            />
                        )}
                    </FormItem>
                    <Row>
                        <Col offset={3} span={3}>
                            <Button size="large" type="primary" htmlType="submit" block>提交</Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }
}

NewsAdd.propTypes = {
    edit_id: PropTypes.any
}


export default Form.create()(NewsAdd)



// WEBPACK FOOTER //
// ./src/routes/ranks/News/NewsAdd.jsx